import React, { useState, useEffect } from 'react';
import { PageHeader, SectionHeading, CallToAction, Communities, Footer } from 'components';
import { Layout } from 'layout';
import profileImage from 'images/profile-image.png'
import swipingVideo from 'images/swiping-hero-animation.mp4';
import swipingVideoCropped from 'images/swiping-hero-animation-cropped.mp4';
import networkBenefits from 'images/feature-benefits.png';
import { useNavigate } from 'react-router-dom';
import { SignInModal, CreateAccountModal, ResetPasswordModal } from 'sub-components';
import { Button } from 'react-bootstrap'

// Background images for horizontal scrolling items
import hackathonBackground from 'images/stock-hackathon.png'
import sideProjectBackground from 'images/stock-casual.png'
import startupBackground from 'images/stock-startup.png'
import artBackground from 'images/stock-art-collab.png'
import passionProjectBackground from 'images/stock-passion-project.png'

// Icons
import Globe05 from "@untitled-ui/icons-react/build/cjs/Globe05";
import BezierCurve02 from "@untitled-ui/icons-react/build/cjs/BezierCurve02";
import MagicWand01 from "@untitled-ui/icons-react/build/cjs/MagicWand01";
import ZapFast from "@untitled-ui/icons-react/build/cjs/ZapFast";
import Rocket02 from "@untitled-ui/icons-react/build/cjs/Rocket02";
import TerminalBrowser from "@untitled-ui/icons-react/build/cjs/TerminalBrowser";
import Youtube from "@untitled-ui/icons-react/build/cjs/Youtube";
import Stars02 from "@untitled-ui/icons-react/build/cjs/Stars02";
import ThumbsUp from "@untitled-ui/icons-react/build/cjs/ThumbsUp";

const EarlyLandingPage = () => {
    const [isSignInToggleOnPrompt, setIsSignInToggleOnPrompt] = useState(false);
    const [redirectURL, setRedirectURL] = useState('');
    const [isNow, setIsNow] = useState(true);

    useEffect(() => {
        const setLoginPrompt = () => {
            const params = new URLSearchParams(window.location.search);
            const promptLogin = params.get('prompt_login');

            if (promptLogin === 'true') {
                setIsSignInToggleOnPrompt(true);
                setRedirectURL(params.get('redirect'));
            }
        };

        setLoginPrompt();
    }, []);

    const handleToggle = () => {
        setIsNow(!isNow);
    };

    const [isSignUpToggleOn, setIsSignUpToggleOn] = useState(false);
    const [isSignInToggleOn, setIsSignInToggleOn] = useState(false);
    const [isContactToggleOn, setIsContactToggleOn] = useState(false);
    const [actionCompleted, setActionCompleted] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    const [isResetPwdToggleOn, setResetPwdToggleOn] = useState(false);
    const navigate = useNavigate();

	const handleSignUpClick = () => {
        setIsSignUpToggleOn(!isSignUpToggleOn);
        setActionCompleted(false);
    };

    const handleSignInClick = () => {
		setIsSignInToggleOn(!isSignInToggleOn);
		setActionCompleted(false);
	};

    const resetPwdClick = () => {
		setResetPwdToggleOn(!isResetPwdToggleOn);
		setActionCompleted(false);
	};

    const handleContactClick = () => {
        setIsContactToggleOn(!isContactToggleOn);
        setActionCompleted(false);
    }

    const handleActionCompleted = () => {
        setActionCompleted(true);
        const id = setTimeout(() => {
            setIsSignUpToggleOn(false);
            setIsContactToggleOn(false);
        }, 1000);
        setTimeoutId(id);
    };

    const handleSignInCompleted = () => {
		setActionCompleted(true);
		navigate('/discovery');
	}

    const resetPwdCompleted = () => {
		setActionCompleted(true);
	}

    return (
        <Layout tabHeader="Home Page">
            <CreateAccountModal isSignUpToggleOn={isSignUpToggleOn} handleClick={handleSignUpClick} handleSignInClick={handleSignInClick}/>
            {isSignInToggleOn && 
                <SignInModal resetPwdClick={resetPwdClick} isSignInToggleOn={isSignInToggleOn} handleClick={handleSignInClick} onActionCompleted={handleSignInCompleted} handleSignUpClick={handleSignUpClick} />
            }
			<ResetPasswordModal isResetPwdToggleOn={isResetPwdToggleOn} handleClick={resetPwdClick} onActionCompleted={resetPwdCompleted} />
            <div className="main-page">
                <div className='colored-background header-section'>
                    <PageHeader
                        displayDiscoveryBtn={'inline'}
                        mainPhoto={swipingVideo}
                        // preHeader={"Tired of collecting useless LinkedIn connections?"}
                        header={"Find purposeful connections \n with others near you."}
                        // subHeader={"Swipe other personal pitches to find and meet local potential partners."}
                        subHeader={"We connect people that are interested in the same things, \n and anchor relationships through local events & collaboration."}
                    />
                    {/* <Banner/> */}
                </div>
                <div className="gray-container">
                    <SectionHeading
                        header="What types of collaboration?"
                    />
                    <div className="horizontalScrollingContainer">
                        <div className="item" style={{ backgroundImage: `url(${startupBackground})` }}>
                            <ZapFast className="icon" />
                            <div>Side Projects</div>
                        </div>
                        <div className="item" style={{ backgroundImage: `url(${hackathonBackground})` }}>
                            <TerminalBrowser className="icon" />
                            <div>Hackathons</div>
                        </div>
                        <div className="item" style={{ backgroundImage: `url(${artBackground})` }}>
                            <Youtube className="icon" />
                            <div>Media Projects</div>
                        </div>
                        <div className="item" style={{ backgroundImage: `url(${sideProjectBackground})` }}>
                            <Rocket02 className="icon" />
                            <div>Startups</div>
                        </div>
                        <div className="item" style={{ backgroundImage: `url(${passionProjectBackground})` }}>
                            <Stars02 className="icon" />
                            <div>Passion Projects</div>
                        </div>
                    </div>
                </div>
                <div className='pitch-simplification-wrapper'>
                    <SectionHeading
                        header="Give us a personal introduction."
                        subHeading="Personify your basic profile with a video pitch."
                    />
                    <picture>
                        <source srcSet={profileImage} media="(max-width: 900px)" />
                        <img src={profileImage} alt="Pitch prompts" />
                    </picture>
                </div>
                <div className="gray-container">
                    <div className='network-benefits-section'>
                        <SectionHeading
                            header="Explore potential collaborators."
                            subHeading={"Swipe through video introductions within specific communities."}
                        />
                        <div className='video-explanation'>
                            <div className='cropped-swiping-video'>
                                <video className='hero' alt="sidejawn-header-photo" autoPlay loop muted playsInline>
                                    <source src={swipingVideoCropped} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div className='explanation'>
                                <div className='promptContainer'>
                                    <Globe05 className='icon' />
                                    <h1 className='colorlib-heading'>Local people.</h1>
                                </div>
                                <div className='promptContainer'>
                                    <BezierCurve02 className='icon' />
                                    <h1>Connected communities.</h1>
                                </div>
                                <div className='promptContainer'>
                                    <ThumbsUp className='icon' />
                                    <h1>Unique events.</h1>
                                </div>
                                <div className='promptContainer'>
                                    <MagicWand01 style={{ color: "gray" }} className='icon' />
                                    <h1 style={{ color: "gray" }}>Recommendations. (coming soon)</h1>
                                </div>
                            </div>
                        </div>
                        <Button style={{marginBottom: '20px'}} className="page-header-btn" variant="primary" onClick={() => navigate('/product/history')}>
                            See what used to be
                        </Button>
                    </div>
                </div>
                <Communities />
                <div className='join-now-wrapper'>
                    <SectionHeading header="We had over 200+ sidejawn members." />
                    <div className='skill-tags-section'>
                        <div className='skill-tags'>
                            <div>
                                Sales & Marketing
                            </div>
                            <div>
                                Software Developers
                            </div>
                            <div>
                                UI/UX Designers
                            </div>
                            <div>
                                Product Specialists
                            </div>
                            <div>
                                Advisors
                            </div>
                            <div>
                                Mentors
                            </div>
                            <div>
                                Creatives
                            </div>
                            <div>
                                Operations Managers
                            </div>
                            <div>
                                University Students
                            </div>
                        </div>
                    </div>
                    <CallToAction
                        actionButtonTitle="Want to see how it all started?"
                    />
                </div>
                {/* <div className="gray-container">
                    <div className='join-now-wrapper'>
                        <SectionHeading subHeading="We'd love to enhance your networking events!"/>
                        <CallToAction 
                            userActionButtonTitle="Let's talk" 
                            imageDesc="sidejawn partners connecting through startup"
                        />
                    </div>
                </div> */}
            </div>
            <Footer />
        </Layout>
    );
};

export default EarlyLandingPage;